module.exports = __webpack_public_path__ + "img/Christmas-Island.19231f6a.png";